export const getLanguage = () => {
  return navigator.language.indexOf('de') !== -1 ? 'de' : 'en';
};
